module.exports = __webpack_public_path__ + "img/image-alt.85949dd9.svg";